import { createSlice } from "@reduxjs/toolkit";
import {
  getAuthList,
  getSummaryCards,
  getReferralLinkDetails,
  getRebateDetails,
  addIBOnboardingPersonalInfo,
  addInvestIBOnboardingSMSReq,
  addIBOnboardingBankInfo,
  addIBOnboardingIdentityVerify,
  addIBOnboardingAddressVerify,
  getCountryList,
  getCountryListInt2,
  getUserAddressInfos,
  getDocumentTypeList,
  getPartnerClients,
  getPartnerTradingVolume,
  getPartnerBalance,
  getPNLShareContractInfo,
  changePersonalPassword,
  getScaAccountInfoList,
  getWalletAccountInfoList,
  getDepositRedirectParameter,
  addWithdrawalInfo,
  addWithdrawalWalletInfo,
  addInternalTransferInfo,
  clearDepositRedirectParameter,
  addInvestIBOnboardingCodeReq,
} from "./thunk";

export const initialState = {
  // Get Auth User
  authData: [],
  authError: {},
  authLoading: false,
  // Get Summary Cards
  summaryCardsData: [],
  summaryCardsError: {},
  // Get Referral Link Details
  referralLinkDetailsData: [],
  referralLinkDetailsError: {},
  // Get Rebate Details
  rebateDetailsData: [],
  rebateDetailsError: {},
  // Post IB Onboarding Personal Info
  addIBOnboardingPersonalInfoData: [],
  addIBOnboardingPersonalInfoError: {},
  // Post Invest IB Onboarding SMS Verification
  addInvestIBOnboardingSMSReqData: [],
  addInvestIBOnboardingSMSReqError: {},
  // Post Invest IB Onboarding OTP Code Req
  addInvestIBOnboardingCodeReqData: [],
  addInvestIBOnboardingCodeReqError: {},
  // Post IB Onboarding Bank Info
  addIBOnboardingBankInfoData: [],
  addIBOnboardingBankInfoError: {},
  // Post IB Onboarding Identity Verification
  addIBOnboardingIdentityVerifyData: [],
  addIBOnboardingIdentityVerifyError: {},
  // Post IB Onboarding Address Verification
  addIBOnboardingAddressVerifyData: [],
  addIBOnboardingAddressVerifyError: {},
  // Get Country List
  getCountryListData: [],
  getCountryListError: {},
  // Get Country List Int2
  getCountryListInt2Data: [],
  getCountryListInt2Error: {},
  // Get Address Info
  getUserAddressInfosData: [],
  getUserAddressInfosError: {},
  // Get Document Type List
  getDocumentTypeListData: [],
  getDocumentTypeListError: {},
  // Get Partner Clients
  getPartnerClientsData: [],
  getPartnerClientsError: {},
  // Get Partner Clients
  getPartnerTradingVolumeData: [],
  getPartnerTradingVolumeError: {},
  // Get Partner Clients
  getPartnerBalanceData: [],
  getPartnerBalanceError: {},
  // Get PNL Share Contract Info
  getPNLShareContractInfoData: [],
  getPNLShareContractInfoError: {},
  // Change Personal Password
  changePersonalPasswordData: [],
  changePersonalPasswordError: {},
  // Get Sca Account Info List Withdrawal / Transfer
  getScaAccountInfoListData: [],
  getScaAccountInfoListError: {},
  // Get Wallet Account Info List
  getWalletAccountInfoListData: [],
  getWalletAccountInfoListError: {},
  // Post Withdrawal Infos
  addWithdrawalInfoData: [],
  addWithdrawalInfoError: {},
  // Post Withdrawal Wallet Infos
  addWithdrawalWalletInfoData: [],
  addWithdrawalWalletInfoError: {},
  // Post Withdrawal Infos
  addInternalTransferInfoData: [],
  addInternalTransferInfoError: {},
  // Get Deposit Redirect Parameter
  getDepositRedirectParameterData: [],
  getDepositRedirectParameterError: {},
};

const DashboardReducer = createSlice({
  name: "Dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAuthList.pending, (state) => {
      state.authLoading = true;
    });
    builder.addCase(getAuthList.fulfilled, (state: any, action: any) => {
      state.authData = action.payload;
      state.authLoading = false;
    });
    builder.addCase(getAuthList.rejected, (state: any, action: any) => {
      state.authError = action.error.message;
      state.authLoading = false;
    });
    // Get Summary Cards
    builder.addCase(getSummaryCards.fulfilled, (state: any, action: any) => {
      state.summaryCardsData = action.payload;
    });
    builder.addCase(getSummaryCards.rejected, (state: any, action: any) => {
      state.summaryCardsError = action.error.message;
    });
    // Get Referral Link Details
    builder.addCase(
      getReferralLinkDetails.fulfilled,
      (state: any, action: any) => {
        state.referralLinkDetailsData = action.payload;
      },
    );
    builder.addCase(
      getReferralLinkDetails.rejected,
      (state: any, action: any) => {
        state.referralLinkDetailsError = action.error.message;
      },
    );
    // Get Rebate Details
    builder.addCase(getRebateDetails.fulfilled, (state: any, action: any) => {
      state.rebateDetailsData = action.payload;
    });
    builder.addCase(getRebateDetails.rejected, (state: any, action: any) => {
      state.rebateDetailsError = action.error.message;
    });
    // Post IB Onboarding Personal Info
    builder.addCase(
      addIBOnboardingPersonalInfo.fulfilled,
      (state: any, action: any) => {
        state.addIBOnboardingPersonalInfoData = action.payload;
      },
    );
    builder.addCase(
      addIBOnboardingPersonalInfo.rejected,
      (state: any, action: any) => {
        state.addIBOnboardingPersonalInfoError = action.error.message;
      },
    );
    // Post Invest IB Onboarding SMS Verification
    builder.addCase(
      addInvestIBOnboardingSMSReq.fulfilled,
      (state: any, action: any) => {
        state.addInvestIBOnboardingSMSReqData = action.payload;
      },
    );
    builder.addCase(
      addInvestIBOnboardingSMSReq.rejected,
      (state: any, action: any) => {
        state.addInvestIBOnboardingSMSReqError = action.error.message;
      },
    );
    // Post Invest IB Onboarding OTP Code Req
    builder.addCase(
      addInvestIBOnboardingCodeReq.fulfilled,
      (state: any, action: any) => {
        state.addInvestIBOnboardingCodeReqData = action.payload;
      },
    );
    builder.addCase(
      addInvestIBOnboardingCodeReq.rejected,
      (state: any, action: any) => {
        state.addInvestIBOnboardingCodeReqError = action.error.message;
      },
    );
    // Post IB Onboarding Bank Info
    builder.addCase(
      addIBOnboardingBankInfo.fulfilled,
      (state: any, action: any) => {
        state.addIBOnboardingBankInfoData = action.payload;
      },
    );
    builder.addCase(
      addIBOnboardingBankInfo.rejected,
      (state: any, action: any) => {
        state.addIBOnboardingBankInfoError = action.error.message;
      },
    );
    // Post IB Onboarding Identity Verification
    builder.addCase(
      addIBOnboardingIdentityVerify.fulfilled,
      (state: any, action: any) => {
        state.addIBOnboardingIdentityVerifyData = action.payload;
      },
    );
    builder.addCase(
      addIBOnboardingIdentityVerify.rejected,
      (state: any, action: any) => {
        state.addIBOnboardingIdentityVerifyError = action.error.message;
      },
    );
    // Post IB Onboarding Address Verification
    builder.addCase(
      addIBOnboardingAddressVerify.fulfilled,
      (state: any, action: any) => {
        state.addIBOnboardingAddressVerifyData = action.payload;
      },
    );
    builder.addCase(
      addIBOnboardingAddressVerify.rejected,
      (state: any, action: any) => {
        state.addIBOnboardingAddressVerifyError = action.error.message;
      },
    );
    // Get Country List
    builder.addCase(getCountryList.fulfilled, (state: any, action: any) => {
      state.getCountryListData = action.payload;
    });
    builder.addCase(getCountryList.rejected, (state: any, action: any) => {
      state.getCountryListError = action.error.message;
    });
    // Get Country List Int2
    builder.addCase(getCountryListInt2.fulfilled, (state: any, action: any) => {
      state.getCountryListInt2Data = action.payload;
    });
    builder.addCase(getCountryListInt2.rejected, (state: any, action: any) => {
      state.getCountryListInt2Error = action.error.message;
    });
    // Get Address Infos
    builder.addCase(
      getUserAddressInfos.fulfilled,
      (state: any, action: any) => {
        state.getUserAddressInfosData = action.payload;
      },
    );
    builder.addCase(getUserAddressInfos.rejected, (state: any, action: any) => {
      state.getUserAddressInfosError = action.error.message;
    });
    // Get Document Type List
    builder.addCase(
      getDocumentTypeList.fulfilled,
      (state: any, action: any) => {
        state.getDocumentTypeListData = action.payload;
      },
    );
    builder.addCase(getDocumentTypeList.rejected, (state: any, action: any) => {
      state.getDocumentTypeListError = action.error.message;
    });

    // Get Partner Clients
    builder.addCase(getPartnerClients.fulfilled, (state: any, action: any) => {
      state.getPartnerClientsData = action.payload;
    });
    builder.addCase(getPartnerClients.rejected, (state: any, action: any) => {
      state.getPartnerClientsError = action.error.message;
    });

    // Get Partner Trading Volume
    builder.addCase(
      getPartnerTradingVolume.fulfilled,
      (state: any, action: any) => {
        state.getPartnerTradingVolumeData = action.payload;
      },
    );
    builder.addCase(
      getPartnerTradingVolume.rejected,
      (state: any, action: any) => {
        state.getPartnerTradingVolumeError = action.error.message;
      },
    );

    // Get Partner Balance
    builder.addCase(getPartnerBalance.fulfilled, (state: any, action: any) => {
      state.getPartnerBalanceData = action.payload;
    });
    builder.addCase(getPartnerBalance.rejected, (state: any, action: any) => {
      state.getPartnerBalanceError = action.error.message;
    });

    // Get PNL Share Contract Info
    builder.addCase(
      getPNLShareContractInfo.fulfilled,
      (state: any, action: any) => {
        state.getPNLShareContractInfoData = action.payload;
      },
    );
    builder.addCase(
      getPNLShareContractInfo.rejected,
      (state: any, action: any) => {
        state.getPNLShareContractInfoError = action.error.message;
      },
    );
    // Post Change Password
    builder.addCase(
      changePersonalPassword.fulfilled,
      (state: any, action: any) => {
        state.changePersonalPasswordData = action.payload;
      },
    );
    builder.addCase(
      changePersonalPassword.rejected,
      (state: any, action: any) => {
        state.changePersonalPasswordError = action.error.message;
      },
    );
    // Get Sca Account Info List Withdrawal / Transfer
    builder.addCase(
      getScaAccountInfoList.fulfilled,
      (state: any, action: any) => {
        state.getScaAccountInfoListData = action.payload;
      },
    );
    builder.addCase(
      getScaAccountInfoList.rejected,
      (state: any, action: any) => {
        state.getScaAccountInfoListError = action.error.message;
      },
    );
    // Get Wallet Account Info List
    builder.addCase(
      getWalletAccountInfoList.fulfilled,
      (state: any, action: any) => {
        state.getWalletAccountInfoListData = action.payload;
      },
    );
    builder.addCase(
      getWalletAccountInfoList.rejected,
      (state: any, action: any) => {
        state.getWalletAccountInfoListError = action.error.message;
      },
    );
    // Post Withdrawal Infos
    builder.addCase(addWithdrawalInfo.fulfilled, (state: any, action: any) => {
      state.addWithdrawalInfoData = action.payload;
    });
    builder.addCase(addWithdrawalInfo.rejected, (state: any, action: any) => {
      state.addWithdrawalInfoError = action.error.message;
    });
    // Post Withdrawal Wallet Infos
    builder.addCase(
      addWithdrawalWalletInfo.fulfilled,
      (state: any, action: any) => {
        state.addWithdrawalWalletInfoData = action.payload;
      },
    );
    builder.addCase(
      addWithdrawalWalletInfo.rejected,
      (state: any, action: any) => {
        state.addWithdrawalWalletInfoError = action.error.message;
      },
    );
    // Post Internal Transfer Infos
    builder.addCase(
      addInternalTransferInfo.fulfilled,
      (state: any, action: any) => {
        state.addInternalTransferInfoData = action.payload;
      },
    );
    builder.addCase(
      addInternalTransferInfo.rejected,
      (state: any, action: any) => {
        state.addInternalTransferInfoError = action.error.message;
      },
    );
    // Get Deposit Redirect Parameter
    builder.addCase(
      getDepositRedirectParameter.fulfilled,
      (state: any, action: any) => {
        state.getDepositRedirectParameterData = action.payload;
      },
    );
    builder
      .addCase(
        getDepositRedirectParameter.rejected,
        (state: any, action: any) => {
          state.getDepositRedirectParameterError = action.error.message;
        },
      )
      .addCase(clearDepositRedirectParameter.fulfilled, (state) => {
        state.getDepositRedirectParameterData = [];
      });
  },
});

export default DashboardReducer.reducer;
